const awsConfig = {
  Auth: {
    cognitoRegion: process.env.REACT_APP_COGNITO_REGION ?? 'us-east-1',
    userPoolId: process.env.REACT_APP_COGNITO_POOL_ID ?? '',
    userPoolWebClientId: process.env.REACT_APP_COGNITO_POOL_CLIENT_ID ?? '',
  },
};

export default awsConfig;
